export default __webpack_public_path__ + "static/149-a70c3ee9736772a90b9dc2b26e498a52.jpg";